<template>
  <div class="projectPage">
                    <div class="projectHeader">
                        <div class="projectTitle">
                            <div class="leftHeader">
                                <div id="projectDetailBtn" class="simpleBtn">
                                    <i class="bi bi-three-dots-vertical"></i>
                                </div>
                                <div class="projectName">
                                    <i class="bi bi-app"></i>
                                    <span>프로젝트명</span>
                                </div>
                            </div>
                            <div class="rightHeader">
                                <button class="grayBtn">
                                    <i class="bi bi-person-add"></i>
                                    <span>초대하기</span>
                                </button>
                            </div>
                        </div>
                        <div class="projectMenu">
                            <div id="feed" class="projectMenuItem active">피드</div>
                            <div id="feed" class="projectMenuItem">업무</div>
                            <div id="feed" class="projectMenuItem">캘린더</div>
                        </div>
                    </div>
                    <div class="projectFeedPageContainer">
                        <div class="projectFeedPage">
                            <!-- 새 글 쓰기 -->
                            <div class="create">
                                <div class="selectCategory">
                                    <div class="simpleBtn simple55Btn">
                                        <i class="bi bi-file-earmark-text"></i>
                                        <span>글</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn">
                                        <i class="bi bi-card-list"></i>
                                        <span>업무</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn">
                                        <i class="bi bi-calendar-week"></i>
                                        <span>일정</span>
                                    </div>
                                </div>
                                <div class="inputTxt">
                                    <div class="placeholder">내용을 입력하세요.</div>
                                    <div class="btnBox">
                                        <i class="bi bi-paperclip"></i>
                                        <i class="bi bi-image"></i>
                                        <i class="bi bi-fonts"></i>
                                    </div>
                                </div>
                            </div>
                            <!-- 피드 리스트 -->
                            <div class="feedList">
                                <div class="feedListHeader">
                                    <div>전체</div>
                                    <div class="simpleBtn">
                                        <i class="bi bi-funnel"></i>
                                        <span>필터</span>
                                    </div>
                                </div>
                                <div class="feedListItemBox">
                                    <!-- 기본 글 피드 -->
                                    <div class="feedListItem textFeed">
                                        <div class="feedListItemDes">
                                            <div class="feedListItemHeader">
                                                <div class="writterInfo">
                                                    <div class="specialUserImg">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="specialUserName">홍길동</div>
                                                    <div class="writeTime">2025-04-09 13:04</div>
                                                </div>
                                                <div class="feedHeaderBtnBox">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-pin"></i>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-three-dots-vertical"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedListItemBody">
                                                <div class="feedBodyTitle">글 제목</div>
                                                <div class="feedBodyTextDetail">글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 </div>
                                            </div>
                                            <div class="feedListItemFooter">
                                                <div class="feedFooterLeft">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-hand-thumbs-up"></i>
                                                        <span>좋아요</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-bookmark"></i>
                                                        <span>북마크</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-clock-history"></i>
                                                        <span>다시 알림</span>
                                                    </div>
                                                </div>
                                                <div class="feedFooterRight">
                                                    <div class="simpleBtn notBtn">
                                                        <span>읽음</span>
                                                        <span><b>1</b></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- 댓글 -->
                                        <div class="feedListItemComment">
                                            <div class="feedCommentHeader">
                                                <span class="lineBtn active">
                                                    <span>댓글</span>
                                                    <span><b>6</b></span>
                                                </span>
                                            </div>
                                            <div class="moreComment txtBtn">이전 댓글 더보기 (1)</div>
                                            <div class="feedCommentBody">
                                                <div class="feedCommentItem">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedCommentItem">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                        <div class="recommentView txtBtn">
                                                            &#9660; 답글 1개
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedCommentItem">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedCommentItem recomment">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedCommentFooter leaveComment">
                                                <div class="leaveCommentUser">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">                                                    
                                                </div>
                                                <div class="leaveCommentInput formRightIcon">
                                                    <input type="text" placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다.">
                                                    <span class="formIcon">
                                                        <i class="bi bi-paperclip"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 일정 피드 -->
                                    <div class="feedListItem scheduleFeed">
                                        <div class="feedListItemDes">
                                            <div class="feedListItemHeader">
                                                <div class="writterInfo">
                                                    <div class="specialUserImg">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="specialUserName">홍길동</div>
                                                    <div class="writeTime">2025-04-09 13:04</div>
                                                </div>
                                                <div class="feedHeaderBtnBox">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-pin"></i>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-three-dots-vertical"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedListItemBody scheduleFeedItem">
                                                <div class="feedBodyscheduleTitle">
                                                    <div class="scheduleCalendar">
                                                        <div class="yearMonth">2025-04</div>
                                                        <div class="date">30</div>
                                                    </div>
                                                    <div class="scheduleInfo">
                                                        <div class="scheduleTitle">일정 제목</div>
                                                        <div class="scheduleDate">2025-04-30 (수), 13:20 - 17:20</div>
                                                    </div>
                                                </div>
                                                <div class="feedBodyDetail">
                                                    <div class="detailItem participant">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-person"></i>
                                                        </div>
                                                        <div class="detailItemDes">
                                                            <div class="participantListBox">
                                                                <div class="participantList">
                                                                    <div class="participantListItem attend">
                                                                        <img src="https://cdn.aitimes.kr/news/photo/202308/28742_43399_942.jpg" alt="img">
                                                                    </div>
                                                                    <div class="participantListItem non-attend">
                                                                        <img src="https://cdn.aitimes.kr/news/photo/202308/28742_43399_942.jpg" alt="img">
                                                                    </div>
                                                                    <div class="participantListItem TBC">
                                                                        <img src="https://cdn.aitimes.kr/news/photo/202308/28742_43399_942.jpg" alt="img">
                                                                    </div>
                                                                </div>
                                                                <span class="underlineBtn">참석자 변경</span>
                                                            </div>
                                                            <div class="participantTotal">
                                                                <div id="attendTotal" class="simpleBtn notBtn">
                                                                    <span>참석</span>
                                                                    <span><b>1</b></span>
                                                                </div>
                                                                <div id="non-attendTotal" class="simpleBtn notBtn">
                                                                    <span>불참</span>
                                                                    <span><b>1</b></span>
                                                                </div>
                                                                <div id="TBCTotal" class="simpleBtn notBtn">
                                                                    <span>미정</span>
                                                                    <span><b>1</b></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem locate">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-geo-alt"></i>
                                                        </div>
                                                        <div class="detailItemDes">
                                                            <div class="textBox">회의실 2</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedBodyAttendBtnBox">
                                                    <button class="biglineBtn blue">참석</button>
                                                    <button class="biglineBtn red">불참</button>
                                                    <button class="biglineBtn gray active">미정</button>
                                                </div>
                                            </div>
                                            <div class="feedListItemFooter">
                                                <div class="feedFooterLeft">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-hand-thumbs-up"></i>
                                                        <span>좋아요</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-bookmark"></i>
                                                        <span>북마크</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-clock-history"></i>
                                                        <span>다시 알림</span>
                                                    </div>
                                                </div>
                                                <div class="feedFooterRight">
                                                    <div class="simpleBtn notBtn">
                                                        <span>읽음</span>
                                                        <span><b>1</b></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- 댓글 -->
                                        <div class="feedListItemComment">
                                            <div class="feedCommentHeader">
                                                <span class="lineBtn active">
                                                    <span>전체</span>
                                                    <span><b>6</b></span>
                                                </span>
                                                <span class="lineBtn">
                                                    <span>댓글</span>
                                                    <span><b>6</b></span>
                                                </span>
                                            </div>
                                            <div class="moreComment txtBtn">이전 댓글 더보기 (1)</div>
                                            <div class="feedCommentBody">
                                                <div class="feedCommentItem noreply">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedCommentItem noreply">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedCommentItem noreply">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedCommentItem noreply">
                                                    <div class="commentLeft">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="commentRight">
                                                        <div class="commentHeader">
                                                            <div class="commentHeaderUser">
                                                                <div class="specialUserName">홍길동</div>
                                                                <div class="writeTime">2025-04-09 13:04</div>
                                                            </div>
                                                            <div class="commentHeaderBtnBox">
                                                                <div id="commentEdit" class="txtBtn">수정</div>
                                                                <div id="commentDelet" class="txtBtn">삭제</div>
                                                            </div>
                                                        </div>
                                                        <div class="commentBody">
                                                            댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 댓글내용 
                                                        </div>
                                                        <div class="commentFooter">
                                                            <div id="reply" class="simpleBtn">
                                                                <i class="bi bi-arrow-return-right"></i>
                                                                <span>댓글</span>
                                                            </div>
                                                            <div id="like" class="simpleBtn">
                                                                <i class="bi bi-hand-thumbs-up"></i>
                                                                <span>좋아요</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedCommentFooter leaveComment">
                                                <div class="leaveCommentUser">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">                                                    
                                                </div>
                                                <div class="leaveCommentInput formRightIcon">
                                                    <input type="text" placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다.">
                                                    <span class="formIcon">
                                                        <i class="bi bi-paperclip"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 업무 피드 / 심플 버전 -->
                                    <div class="feedListItem taskFeed">
                                        <div class="feedListItemDes">
                                            <div class="feedListItemHeader">
                                                <div class="writterInfo">
                                                    <div class="specialUserImg">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="specialUserName">홍길동</div>
                                                    <div class="writeTime">2025-04-09 13:04</div>
                                                </div>
                                                <div class="feedHeaderBtnBox">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-pin"></i>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-three-dots-vertical"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedListItemBody taskFeedItem">
                                                <div class="feedBodyTaskTitle">
                                                    <div class="feedBodyTitle">업무 제목</div>
                                                    <span class="taskNumber biglineBtn">업무번호 7</span>    
                                                </div>
                                                <div class="feedBodyDetail">
                                                    <div class="detailItem status">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-bar-chart-steps"></i>
                                                        </div>
                                                        <div class="detailItemDes">
                                                            <div class="statusBtnBox">
                                                                <div class="statusBtn request">요청</div>
                                                                <div class="statusBtn inProgress">진행</div>
                                                                <div class="statusBtn feedback">피드백</div>
                                                                <div class="statusBtn completed">완료</div>
                                                                <div class="statusBtn onHold">보류</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem manager">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-person"></i>
                                                        </div>
                                                        <div class="flexAlignCenter">
                                                            <div class="detailItemDes">
                                                                <div class="selectedUser">
                                                                    <div class="userInfo">
                                                                        <div class="specialUserImg">
                                                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                                        </div>
                                                                        <div class="specialUserName">홍길동</div>
                                                                    </div>
                                                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                                                </div>
                                                            </div>
                                                            <span class="underlineBtn">담당자 변경</span>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem endDate">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-calendar"></i>
                                                        </div>
                                                        <div class="flexAlignCenter">
                                                            <div class="detailItemDes">
                                                                <div class="textBox">
                                                                    <span>2025-04-30 (수) 까지</span>
                                                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="subTaskListBox">
                                                        <button class="biglineBtn">
                                                            <i class="bi bi-plus-lg"></i>
                                                            <span>항목추가입력</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="feedBodyTextDetail">글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 </div>
                                                <div class="feedBodySubTaskBox">
                                                    <div class="subTaskTitleBox">
                                                        <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                                                        <span class="subTaskTitle">하위업무</span>
                                                    </div>
                                                    <div class="subTaskListBox">
                                                        <button class="biglineBtn">
                                                            <i class="bi bi-plus-lg"></i>
                                                            <span>하위업무 추가</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedListItemFooter">
                                                <div class="feedFooterLeft">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-hand-thumbs-up"></i>
                                                        <span>좋아요</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-bookmark"></i>
                                                        <span>북마크</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-clock-history"></i>
                                                        <span>다시 알림</span>
                                                    </div>
                                                </div>
                                                <div class="feedFooterRight">
                                                    <div class="simpleBtn notBtn">
                                                        <span>읽음</span>
                                                        <span><b>1</b></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="feedListItemComment">
                                            <div class="feedCommentFooter leaveComment">
                                                <div class="leaveCommentUser">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">                                                    
                                                </div>
                                                <div class="leaveCommentInput formRightIcon">
                                                    <input type="text" placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다.">
                                                    <span class="formIcon">
                                                        <i class="bi bi-paperclip"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 업무 피드 / 풀 버전 -->
                                    <div class="feedListItem taskFeed">
                                        <div class="feedListItemDes">
                                            <div class="feedListItemHeader">
                                                <div class="writterInfo">
                                                    <div class="specialUserImg">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="specialUserName">홍길동</div>
                                                    <div class="writeTime">2025-04-09 13:04</div>
                                                </div>
                                                <div class="feedHeaderBtnBox">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-pin"></i>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-three-dots-vertical"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedListItemBody taskFeedItem">
                                                <div class="feedBodyTaskTitle">
                                                    <div class="feedBodyTitle">업무 제목</div>
                                                    <span class="taskNumber biglineBtn">업무번호 7</span>    
                                                </div>
                                                <div class="feedBodyDetail">
                                                    <div class="detailItem status">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-bar-chart-steps"></i>
                                                        </div>
                                                        <div class="detailItemDes">
                                                            <div class="statusBtnBox">
                                                                <div class="statusBtn request active">요청</div>
                                                                <div class="statusBtn inProgress active">진행</div>
                                                                <div class="statusBtn feedback active">피드백</div>
                                                                <div class="statusBtn completed active">완료</div>
                                                                <div class="statusBtn onHold active">보류</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem manager">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-person"></i>
                                                        </div>
                                                        <div class="flexAlignCenter">
                                                            <div class="detailItemDes">
                                                                <div class="selectedUser">
                                                                    <div class="userInfo">
                                                                        <div class="specialUserImg">
                                                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                                        </div>
                                                                        <div class="specialUserName">홍길동</div>
                                                                    </div>
                                                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                                                </div>
                                                            </div>
                                                            <span class="underlineBtn">담당자 변경</span>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem startDate">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-calendar"></i>
                                                        </div>
                                                        <div class="flexAlignCenter">
                                                            <div class="detailItemDes">
                                                                <div class="textBox">
                                                                    <span>2025-04-10 (목) 부터</span>
                                                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem endDate">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-calendar"></i>
                                                        </div>
                                                        <div class="flexAlignCenter">
                                                            <div class="detailItemDes">
                                                                <div class="textBox">
                                                                    <span>2025-04-30 (수) 까지</span>
                                                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem priority">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-flag"></i>
                                                        </div>
                                                        <div class="flexAlignCenter">
                                                            <div class="detailItemDes">
                                                                <div class="textBox">
                                                                    <span class="simpleBtn notBtn priority1">
                                                                        <i class="bi bi-fire"></i>
                                                                        <span>긴급</span>
                                                                    </span>
                                                                    <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="detailItem progress">
                                                        <div class="detailItemIcon">
                                                            <i class="bi bi-segmented-nav"></i>
                                                        </div>
                                                        <div class="flexAlignCenter">
                                                            <div class="detailItemDes">
                                                                <div class="progressBox">
                                                                    <progress max="100" value="70"></progress>
                                                                    <span>70%</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="feedBodyTextDetail">글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 글 내용 </div>
                                                <div class="feedBodySubTaskBox">
                                                    <div class="subTaskTitleBox">
                                                        <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                                                        <span class="subTaskTitle">하위업무</span>
                                                    </div>
                                                    <div class="subTaskListBox">
                                                        <div class="subTaskListItem">
                                                            <div class="subTaskInfo">
                                                                <span class="statusBtnSmall request">요청</span>
                                                                <span class="subTaskTxt">업무에 대한 글 내용입니다.</span>
                                                                <span class="subTaskComment">
                                                                    <i class="bi bi-chat-square-dots"></i>
                                                                    <b>1</b>
                                                                </span>
                                                            </div>
                                                            <div class="writterInfo">
                                                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                            </div>
                                                        </div>
                                                        <div class="subTaskListItem">
                                                            <div class="subTaskInfo">
                                                                <span class="statusBtnSmall inProgress">진행</span>
                                                                <span class="subTaskTxt">업무에 대한 글 내용입니다.</span>
                                                                <span class="subTaskComment">
                                                                    <i class="bi bi-chat-square-dots"></i>
                                                                    <b>1</b>
                                                                </span>
                                                            </div>
                                                            <div class="writterInfo">
                                                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                            </div>
                                                        </div>
                                                        <div class="subTaskListItem">
                                                            <div class="subTaskInfo">
                                                                <span class="statusBtnSmall feedback">피드백</span>
                                                                <span class="subTaskTxt">업무에 대한 글 내용입니다.</span>
                                                                <span class="subTaskComment">
                                                                    <i class="bi bi-chat-square-dots"></i>
                                                                    <b>1</b>
                                                                </span>
                                                            </div>
                                                            <div class="writterInfo">
                                                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                            </div>
                                                        </div>
                                                        <div class="subTaskListItem">
                                                            <div class="subTaskInfo">
                                                                <span class="statusBtnSmall completed">완료</span>
                                                                <span class="subTaskTxt">업무에 대한 글 내용입니다.</span>
                                                                <span class="subTaskComment">
                                                                    <i class="bi bi-chat-square-dots"></i>
                                                                    <b>1</b>
                                                                </span>
                                                            </div>
                                                            <div class="writterInfo">
                                                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                            </div>
                                                        </div>
                                                        <div class="subTaskListItem">
                                                            <div class="subTaskInfo">
                                                                <span class="statusBtnSmall onHold">보류</span>
                                                                <span class="subTaskTxt">업무에 대한 글 내용입니다.</span>
                                                                <span class="subTaskComment">
                                                                    <i class="bi bi-chat-square-dots"></i>
                                                                    <b>1</b>
                                                                </span>
                                                            </div>
                                                            <div class="writterInfo">
                                                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="subTaskListBox">
                                                        <button class="biglineBtn">
                                                            <i class="bi bi-plus-lg"></i>
                                                            <span>하위업무 추가</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="feedListItemFooter">
                                                <div class="feedFooterLeft">
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-hand-thumbs-up"></i>
                                                        <span>좋아요</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-bookmark"></i>
                                                        <span>북마크</span>
                                                    </div>
                                                    <div class="simpleBtn">
                                                        <i class="bi bi-clock-history"></i>
                                                        <span>다시 알림</span>
                                                    </div>
                                                </div>
                                                <div class="feedFooterRight">
                                                    <div class="simpleBtn notBtn">
                                                        <span>읽음</span>
                                                        <span><b>1</b></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 댓글 -->
                                        <div class="feedListItemComment">
                                            <div class="feedCommentFooter leaveComment">
                                                <div class="leaveCommentUser">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">                                                    
                                                </div>
                                                <div class="leaveCommentInput formRightIcon">
                                                    <input type="text" placeholder="줄바꿈 Shift + Enter / 입력 Enter 입니다.">
                                                    <span class="formIcon">
                                                        <i class="bi bi-paperclip"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 글 작성 모달 -->
                <div class="modalBg createTextFeed ">
                    <div class="modalBox createTextFeedBox ">
                        <div class="modalHeader">
                            <div class="modalTitleBox">
                                <div class="modalTitle">
                                    <h5>게시물 작성</h5>
                                    <span class="gap"></span>
                                    <span class="modalchangeProjectBox">
                                        <i class="bi bi-chevron-down"></i>
                                        <div class="selectedProject">
                                            <i class="bi bi-app"></i><span>프로젝트명</span>
                                        </div>
                                    </span>
                                </div>
                                <div class="modalHeaderBtnBox">
                                    <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                                    <span class="closeBtn"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <div class="modalMenu">
                                <div class="selectCategory">
                                    <div class="simpleBtn simple55Btn active">
                                        <i class="bi bi-file-earmark-text"></i>
                                        <span>글</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn">
                                        <i class="bi bi-card-list"></i>
                                        <span>업무</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn">
                                        <i class="bi bi-calendar-week"></i>
                                        <span>일정</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalBody">
                            <div class="modalFeedTitleInputBox">
                                <input type="text" class="modalFeedTitleInput" placeholder="제목을 작성하세요.">
                            </div>
                            <div class="modalFeedDesInputBox">
                                <textarea name="" id="" class="modalFeedDesInput" placeholder="내용을 작성하세요."></textarea>
                            </div>
                        </div>
                        <div class="modalFooter">
                            <div class="modalFooterBtnBox">
                                <div class="btnBox">
                                    <i class="bi bi-fonts"></i>
                                    <i class="bi bi-paperclip"></i>
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                            </div>
                            <div class="modalFooterBtnBox">
                                <div class="dropdown">
                                    <div class="dropdown-button" onclick="toggleDropdown()">전체공개</div>
                                    <div class="dropdown-menu" id="dropdownMenu">
                                      <div class="dropdown-item" onclick="selectItem(this)">전체공개</div>
                                      <div class="dropdown-item" onclick="selectItem(this)">프로젝트 관리자만</div>
                                    </div>
                                  </div>
                                  <div class="preStorage">
                                    <span>임시저장</span>
                                    <span class="gap"></span>
                                    <span><b>0</b></span>
                                  </div>
                                  <button class="blueBtn">등록</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 업무 작성 모달 -->
                <div class="modalBg createTaskFeed ">
                    <div class="modalBox createTaskFeedBox">
                        <div class="modalHeader">
                            <div class="modalTitleBox">
                                <div class="modalTitle">
                                    <h5>게시물 작성</h5>
                                    <span class="gap"></span>
                                    <span class="modalchangeProjectBox">
                                        <i class="bi bi-chevron-down"></i>
                                        <div class="selectedProject">
                                            <i class="bi bi-app"></i><span>프로젝트명</span>
                                        </div>
                                    </span>
                                </div>
                                <div class="modalHeaderBtnBox">
                                    <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                                    <span class="closeBtn"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <div class="modalMenu">
                                <div class="selectCategory">
                                    <div class="simpleBtn simple55Btn ">
                                        <i class="bi bi-file-earmark-text"></i>
                                        <span>글</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn active">
                                        <i class="bi bi-card-list"></i>
                                        <span>업무</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn">
                                        <i class="bi bi-calendar-week"></i>
                                        <span>일정</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalBody">
                            <div class="modalFeedTitleInputBox">
                                <input type="text" class="modalFeedTitleInput" placeholder="제목을 작성하세요.">
                            </div>
                            <div class="modalFeedDetailItemBox">

                                <div class="detailItem status">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-bar-chart-steps"></i>
                                    </div>
                                    <div class="detailItemDes">
                                        <div class="statusBtnBox">
                                            <div class="statusBtn request">요청</div>
                                            <div class="statusBtn inProgress">진행</div>
                                            <div class="statusBtn feedback">피드백</div>
                                            <div class="statusBtn completed">완료</div>
                                            <div class="statusBtn onHold">보류</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="detailItem manager">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-person"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 담당자 추가 시 생성 ▼ -->
                                        <!-- <div class="detailItemDes">
                                            <div class="selectedUser">
                                                <div class="userInfo">
                                                    <div class="specialUserImg">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="specialUserName">홍길동</div>
                                                </div>
                                                <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div> -->
                                        <span class="underlineBtn">담당자 추가</span>
                                        <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                                        <div class="peopleSelectBox">
                                          <div class="peopleSearch formRightIcon">
                                            <input type="search" name="peopleSearch" id="peopleSearch" placeholder="검색어를 입력해주세요">
                                            <span class="formIcon">
                                              <i class="bi bi-search"></i>
                                            </span>
                                          </div>
                                          <div class="peopleListBox">
                                            <div class="peopleList">
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                                <div class="detailItem startDate">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-calendar"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 시작일 추가 시 생성 ▼ -->
                                        <!-- <div class="detailItemDes">
                                            <div class="textBox">
                                                <span>2025-04-30 (수) 까지</span>
                                                <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div> -->
                                        <span class="underlineBtn">시작일 추가</span>
                                    </div>
                                </div>

                                <div class="detailItem endDate">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-calendar"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 마감일 추가 시 생성 ▼ -->
                                        <!-- <div class="detailItemDes">
                                            <div class="textBox">
                                                <span>2025-04-30 (수) 까지</span>
                                                <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div> -->
                                        <span class="underlineBtn">마감일 추가</span>
                                    </div>
                                </div>

                                <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                                <div class="detailItem priority">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-flag"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <!-- ▼ 우선순위 추가 시 생성 ▼ -->
                                        <!-- <div class="detailItemDes">
                                            <div class="textBox">
                                                <span class="simpleBtn notBtn priority1">
                                                    <i class="bi bi-fire"></i>
                                                    <span>긴급</span>
                                                </span>
                                                <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div> -->
                                        <span class="underlineBtn">우선순위 추가</span>
                                        <!-- ▼ 우선순위 추가 시 class="active" 추가 -> 나타남 -->
                                        <div class="prioritySelectBox">
                                            <div class="simpleBtn priority4">
                                                <i class="bi bi-caret-down-fill"></i>
                                                <span>낮음</span>
                                            </div>
                                            <div class="simpleBtn priority3">
                                                <i class="bi bi-caret-right-fill"></i>
                                                <span>보통</span>
                                            </div>
                                            <div class="simpleBtn priority2">
                                                <i class="bi bi-caret-up-fill"></i>
                                                <span>높음</span>
                                            </div>
                                            <div class="simpleBtn priority1">
                                                <i class="bi bi-fire"></i>
                                                <span>긴급</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- ▼▼▼ + 항목추가입력 시 생성 ▼▼▼ -->
                                <div class="detailItem progress">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-segmented-nav"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes">
                                            <div class="progressBox">
                                                <progress max="100" value="0"></progress>
                                                <span>0%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="subTaskListBox">
                                    <button class="biglineBtn">
                                        <i class="bi bi-plus-lg"></i>
                                        <span>항목추가입력</span>
                                    </button>
                                </div>
                            </div>
                            <div class="modalFeedDesInputBox">
                                <textarea name="" id="" class="modalFeedDesInput" placeholder="내용을 작성하세요."></textarea>
                            </div>
                            <div class="">
                                <div class="feedBodySubTaskBox">
                                    <div class="subTaskTitleBox">
                                        <span class="subTaskIcon"><i class="bi bi-list-task"></i></span>
                                        <span class="subTaskTitle">하위업무</span>
                                    </div>
                                    <div class="subTaskListBox">
                                        <div class="subTaskListItem">
                                            <div class="subTaskInfo">
                                                <span class="statusBtnSmall request">요청</span>
                                                <span class="subTaskTxt"><input type="text" placeholder="업무명 입력"></span>
                                            </div>
                                            <div class="subTaskInfo">
                                                <span class="circleBtn">
                                                    <i class="bi bi-calendar"></i>
                                                </span>
                                                <span class="circleBtn">
                                                    <i class="bi bi-caret-down-fill"></i>
                                                </span>
                                                <span class="circleBtn">
                                                    <i class="bi bi-person"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="subTaskListBox">
                                        <button class="biglineBtn">
                                            <i class="bi bi-plus-lg"></i>
                                            <span>하위업무 추가</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalFooter">
                            <div class="modalFooterBtnBox">
                                <div class="btnBox">
                                    <i class="bi bi-fonts"></i>
                                    <i class="bi bi-paperclip"></i>
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                            </div>
                            <div class="modalFooterBtnBox">
                                <div class="dropdown">
                                    <div class="dropdown-button" onclick="toggleDropdown()">전체공개</div>
                                    <div class="dropdown-menu" id="dropdownMenu">
                                      <div class="dropdown-item" onclick="selectItem(this)">전체공개</div>
                                      <div class="dropdown-item" onclick="selectItem(this)">프로젝트 관리자만</div>
                                    </div>
                                  </div>
                                  <div class="preStorage">
                                    <span>임시저장</span>
                                    <span class="gap"></span>
                                    <span><b>0</b></span>
                                  </div>
                                  <button class="blueBtn">등록</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 일정 작성 모달 -->
                <div class="modalBg createScheduleFeed ">
                    <div class="modalBox createTextFeedBox">
                        <div class="modalHeader">
                            <div class="modalTitleBox">
                                <div class="modalTitle">
                                    <h5>게시물 작성</h5>
                                    <span class="gap"></span>
                                    <span class="modalchangeProjectBox">
                                        <i class="bi bi-chevron-down"></i>
                                        <div class="selectedProject">
                                            <i class="bi bi-app"></i><span>프로젝트명</span>
                                        </div>
                                    </span>
                                </div>
                                <div class="modalHeaderBtnBox">
                                    <span class="dashBtn"><i class="bi bi-dash-lg"></i></span>
                                    <span class="closeBtn"><i class="bi bi-x-lg"></i></span>
                                </div>
                            </div>
                            <div class="modalMenu">
                                <div class="selectCategory">
                                    <div class="simpleBtn simple55Btn ">
                                        <i class="bi bi-file-earmark-text"></i>
                                        <span>글</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn">
                                        <i class="bi bi-card-list"></i>
                                        <span>업무</span>
                                    </div>
                                    <div class="simpleBtn simple55Btn active">
                                        <i class="bi bi-calendar-week"></i>
                                        <span>일정</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modalBody">
                            <div class="modalFeedTitleInputBox">
                                <input type="text" class="modalFeedTitleInput" placeholder="제목을 작성하세요.">
                            </div>
                            <div class="modalFeedDetailItemBox">

                                <div class="detailItem scheduleDateTime">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-calendar"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes">
                                            <div class="dateBox">
                                                <input type="datetime-local" name="" id="startDateTime">
                                                <span><i class="bi bi-dash-lg"></i></span>
                                                <input type="datetime-local" name="" id="endDateTime">
                                            </div>
                                        </div> 
                                        <label class="checkboxBox">
                                            <input type="checkbox" name="" id="">
                                            <span>종일</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="detailItem manager">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-person"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes">
                                            <div class="selectedUser">
                                                <div class="userInfo">
                                                    <div class="specialUserImg">
                                                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&s" alt="userProfileImg">
                                                    </div>
                                                    <div class="specialUserName">홍길동</div>
                                                </div>
                                                <span class="xBtn"><i class="bi bi-x-lg"></i></span>
                                            </div>
                                        </div>
                                        <span class="underlineBtn">참석자 추가</span>
                                        <!-- ▼ 담당자 추가 시 class="active" 추가 -> 나타남 -->
                                        <div class="peopleSelectBox">
                                          <div class="peopleSearch formRightIcon">
                                            <input type="search" name="peopleSearch" id="peopleSearch" placeholder="검색어를 입력해주세요">
                                            <span class="formIcon">
                                              <i class="bi bi-search"></i>
                                            </span>
                                          </div>
                                          <div class="peopleListBox">
                                            <div class="peopleList">
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="peopleItem">
                                                <div class="specialUserInfo">
                                                  <div class="specialUserImg">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqO7meRkePsxb4OVmsp65Bqdp1bBH4B5zTKA&amp;s" alt="userProfileImg">
                                                  </div>
                                                  <div class="specialUserDes">
                                                    <div class="specialUserName">홍길동 <span>사원</span></div>
                                                    <div class="specialUserTeam">연구개발본부 개발팀</div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="detailItem locate">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-geo-alt"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <div class="detailItemDes">
                                            <input type="text" placeholder="장소를 입력하세요.">
                                        </div>
                                    </div>
                                </div>

                                
                                <!-- ▼ 줌 링크 추가 기능은 유료버전에만 해당되어 일단 항목만 넣어놓겠습니다 ▼ -->
                                <div class="detailItem zoomLink">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-camera-video"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                        <span class="underlineBtn">화상회의 추가</span>
                                    </div>
                                </div>

                                <div class="detailItem alretTime">
                                    <div class="detailItemIcon">
                                        <i class="bi bi-bell"></i>
                                    </div>
                                    <div class="flexAlignCenter">
                                            <select id="options">
                                                <option value="1">없음</option>
                                                <option value="2">10분 전 미리 알림</option>
                                                <option value="3">30분 전 미리 알림</option>
                                                <option value="4">1시간 전 미리 알림</option>
                                                <option value="5">2시간 전 미리 알림</option>
                                                <option value="6">3시간 전 미리 알림</option>
                                                <option value="7">1일 전 미리 알림</option>
                                                <option value="8">2일 전 미리 알림</option>
                                                <option value="9">7일 전 미리 알림</option>
                                            </select>
                                    </div>
                                </div>

                            </div>
                            <div class="modalFeedDesInputBox">
                                <textarea name="" id="" class="modalFeedDesInput" placeholder="내용을 작성하세요."></textarea>
                            </div>
                        </div>
                        <div class="modalFooter">
                            <div class="modalFooterBtnBox">
                                <div class="btnBox">
                                    <i class="bi bi-fonts"></i>
                                    <i class="bi bi-paperclip"></i>
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                            </div>
                            <div class="modalFooterBtnBox">
                                <div class="dropdown">
                                    <div class="dropdown-button" onclick="toggleDropdown()">전체공개</div>
                                    <div class="dropdown-menu" id="dropdownMenu">
                                      <div class="dropdown-item" onclick="selectItem(this)">전체공개</div>
                                      <div class="dropdown-item" onclick="selectItem(this)">프로젝트 관리자만</div>
                                    </div>
                                  </div>
                                  <div class="preStorage">
                                    <span>임시저장</span>
                                    <span class="gap"></span>
                                    <span><b>0</b></span>
                                  </div>
                                  <button class="blueBtn">등록</button>
                            </div>
                        </div>
                    </div>
                </div>
</template>

<script>
export default {
  name: "ReportList",
  data() {
    return {
      subMenuGroups: [
        {
          title: "프로젝트 그룹 1",
          open: true,
          projects: ["프로젝트명 A", "프로젝트명 B", "프로젝트명 C"],
        },
        {
          title: "프로젝트 그룹 2",
          open: true,
          projects: ["프로젝트명 D", "프로젝트명 E"],
        },
      ],
    };
  },
  methods: {
    toggleGroup(index) {
      this.subMenuGroups[index].open = !this.subMenuGroups[index].open;
    },
  },
};
</script>